import React, { useState } from "react";
import { Link } from "react-router-dom";

import "./Preset.scss";

import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import CartList from "../../components/preset/CartList";

import PresetList from "../../components/preset/PresetList";

export default function Preset() {
  const [cartPage, setCartPage] = useState(0);
  const [cartList, setCartList] = useState([]);
  const [cartViewList, setCartViewList] = useState([]);

  function addPresetItem(item) {
    const filtered = cartList.filter((i) => i.pluCd === item.pluCd);
    if (filtered.length > 0) {
      const idx = cartList.indexOf(filtered[0]);

      let newItem = filtered[0];
      newItem.qty = newItem.qty + 1;
      newItem.totAmt = newItem.totAmt + newItem.price;

      setCartList([
        ...cartList.slice(0, idx),
        newItem,
        ...cartList.slice(idx + 1, cartList.length),
      ]);

      const newPage = Math.ceil((idx + 1) / 3) - 1;
      setCartPage(newPage);
      setCartViewList(cartList.slice(newPage * 3, (newPage + 1) * 3));
    } else {
      item.qty = 1;
      item.totAmt = item.price;
      if (cartList.length >= 3 && cartList.length % 3 === 0) {
        setCartViewList([item]);
      } else {
        if (cartPage === Math.ceil((cartList.length + 1) / 3) - 1)
          setCartViewList([...cartViewList, item]);
        else {
          const lastPage = Math.ceil((cartList.length + 1) / 3) - 1;
          setCartPage(lastPage);
          setCartViewList([
            ...cartList.slice(lastPage * 3, (lastPage + 1) * 3),
            item,
          ]);
        }
      }
      setCartList([...cartList, item]);
    }
  }

  return (
    <div className="preset">
      <Header
        linkTo="/additem"
        scoMsg={"바코드 없는 채소 · 과일"}
        scoMsg2={
          "바코드가 없는 채소, 과일 상품의 사진을 눌러주세요\r\n바코드가 안찍히는 상품은 바코드 직접 입력을 눌러주세요"
        }
        kioskMsg={"상품을\r\n등록해주세요"}
      />
      <div className="body">
        <CartList
          list={cartList}
          viewList={cartViewList}
          page={cartPage}
          setList={setCartList}
          setViewList={setCartViewList}
          setPage={setCartPage}
          addPresetItem={addPresetItem}
        />
        <PresetList addPresetItem={addPresetItem} />
      </div>
      <div className="footer-preset">
        <div className="footer-left">
          <Link
            to="/additem"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <div className="footer-cancel">취소</div>
          </Link>
          <div className="footer-add">담기</div>
        </div>
        <div className="footer-right">
          <div className="footer-call">호출</div>
          <div className="footer-barcode">바코드 직접입력</div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
